import { Badge, Flex, Grid, Label, Loader } from "@aws-amplify/ui-react";
import { CCard } from "@coreui/react";
import LocalizedStrings from "react-localization";
import moment from "moment";
import { globalStrings } from "config/translations/es";
import { useRef } from "react";
import { Edit } from "@mui/icons-material";

const ServiceOrderLogSimple = ({ item, onChangeDate }) => {
  const inputRef = useRef(null);

  const handleEditClick = () => {
    inputRef.current?.showPicker?.();
    if (!inputRef.current?.showPicker) inputRef.current?.click();
  };

  const handleChange = (e) => {
    const newDate = e.target.value;
    if (newDate && onChangeDate) onChangeDate(item.id, newDate);
  };

  return (
    <CCard
      className="p-3"
      borderRadius="medium"
      variation="outlined"
      style={{ height: "100%" }}
    >
      <Grid gap={6}>
        <Flex style={styles.card}>
          <Label>{strings.user}: </Label>
          <span className="text-muted">
            {item.hasOwnProperty("userName") ? item.userName : <Loader />}
          </span>
        </Flex>
        <Flex style={styles.card}>
          <Label>{strings.createdAt}: </Label>
          <span className="text-muted">
            {moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss")}
          </span>
          <Edit
            color="action"
            fontSize="14"
            style={{ cursor: "pointer" }}
            onClick={handleEditClick}
          />
          <input
            ref={inputRef}
            type="datetime-local"
            style={{
              opacity: 0,
              position: "absolute",
              pointerEvents: "none",
            }}
            defaultValue={moment(item.createdAt).format("YYYY-MM-DDTHH:mm")}
            onChange={handleChange}
          />
        </Flex>
        {item.status && (
          <Flex style={styles.card}>
            <Label>{strings.status}: </Label>
            <Badge width="fit-content" variation="info">
              {globalStrings.serviceOrderStatus[item.status] || item.status}
            </Badge>
          </Flex>
        )}
        {item.assignedExecutor && (
          <Flex style={styles.card}>
            <Label>{strings.assignedExecutor}: </Label>
            <span className="text-muted">
              {item.hasOwnProperty("assignedExecutorName") ? (
                item.assignedExecutorName
              ) : (
                <Loader />
              )}
            </span>
          </Flex>
        )}
      </Grid>
    </CCard>
  );
};

const styles = {
  card: {
    gap: 6,
    flexWrap: "wrap",
    alignItems: "center",
  },
};

const strings = new LocalizedStrings({
  es: {
    createdAt: "Fecha",
    user: "Responsable",
    assignedExecutor: "Ejecutor Asignado",
    status: "Estado",
  },
});

export default ServiceOrderLogSimple;
